import type { ComponentPropsWithRef } from 'react'

export interface TextareaInputProps extends Omit<
    ComponentPropsWithRef<'textarea'>,
    'value' | 'defaultValue'
> {
    defaultValue?: string | number | readonly string[] | null
    useBookingFormThemeCssVariables?: boolean
}

export function TextareaInput({
    defaultValue,
    useBookingFormThemeCssVariables = false,
    className = '',
    name,
    ...textareaProps
}: TextareaInputProps) {
    const focusClassName = useBookingFormThemeCssVariables
        ? 'focus:ring-booking-form-theme-main-background-color focus:border-booking-form-theme-main-background-color'
        : 'focus:ring-primary focus:border-primary'

    return (
        <textarea
            {...textareaProps}
            id={textareaProps.id ?? name}
            name={name}
            defaultValue={defaultValue ?? undefined}
            className={`px-3 py-2 shadow-xs bg-white border border-stone-200 rounded-lg2 placeholder-gray-300 w-full disabled:bg-stone-100 disabled:text-gray-500 disabled:select-none disabled:cursor-not-allowed ${focusClassName} ${className}`}
        />
    )
}
